export function randomBetween(min: number, max: number) {
  return Math.random() * (max - min) + min;
}
